import { render, staticRenderFns } from "./AgencySettingsPage.vue?vue&type=template&id=c80fbe04&"
import script from "./AgencySettingsPage.vue?vue&type=script&lang=js&"
export * from "./AgencySettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports